import React from "react";
import Section from "../components/shared/Section";
import { FileDown } from "lucide-react";

export default function Catalogue() {
  return (
    <Section id="catalogue">
      <div className="relative overflow-hidden rounded-3xl border border-yellow-400/30 bg-gradient-to-br from-yellow-400/10 to-amber-400/5 p-8 md:p-12 shadow-[0_0_0_1px_rgba(250,204,21,0.15)_inset] transition-all duration-300 hover:shadow-yellow-500/20 group">

        {/* Background Accent */}
        <div className="pointer-events-none absolute -top-10 -right-10 h-40 w-40 rounded-full bg-yellow-400/10 blur-2xl opacity-30 group-hover:opacity-50 transition" />

        <div className="text-center sm:text-left">
          <h3 className="text-2xl sm:text-3xl font-semibold tracking-tight text-yellow-200">
            Download Our Catalogues
          </h3>

          <p className="mt-4 text-neutral-300 max-w-xl mx-auto sm:mx-0 leading-relaxed">
            Explore our product range in detailed PDF catalogues — available for different applications with specifications and finishes.
          </p>

          {/* Buttons */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-6 items-center sm:items-start justify-center sm:justify-start">
            {/* Catalogue 1 */}
            <a
              href="/metalpatti-catlog1.pdf"
              className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-black bg-gradient-to-br from-yellow-300 to-amber-400 shadow-md hover:shadow-lg hover:brightness-110 transition"
              download
            >
              <FileDown className="h-5 w-5" />
              SS 304 Sheet Catalogue
            </a>

            {/* Catalogue 2 */}
            <a
              href="/metalpatti-catlog2.pdf"
              className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-black bg-gradient-to-br from-yellow-300 to-amber-400 shadow-md hover:shadow-lg hover:brightness-110 transition"
              download
            >
              <FileDown className="h-5 w-5" />
              SS 304 Profile Catalogue
            </a>
          </div>
        </div>
      </div>
    </Section>
  );
}
